import { Box, Card, CardContent, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { returnNetwork } from "../../utils/NetworkFunctions.js";
import veryfy from "../../assets/images/checked.png";
import { getDecimalsByCrypto } from "../../utils/cryptoCurrenciesUtils.js";

const DepositVerified = ({ cryptoCurrency, network, title, deposit }) => {
	let isMobile = false;

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}
	return (
		<>
			{deposit?.currencyAmount > 0 ? (
				<Grid sx={{ width: isMobile ? "100%" : 500 }}>
					<Card>
						<CardContent>
							<Box sx={{ marginTop: 2 }}>
								<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
									{title}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<Typography color="#0560FB" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
									{`${cryptoCurrency} ${returnNetwork(network, cryptoCurrency)} Network`}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
									{`Deposit Verified`}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<img src={veryfy} />
							</Box>
							<Box sx={{ textAlign: "center", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
								<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
									{deposit.currencyAmount > 0 ? `$${parseFloat(deposit.currencyAmount).toFixed(2)}` : ""}
								</Typography>
							</Box>
							<Box sx={{ textAlign: "justify", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
								<Typography sx={{ fontSize: "16px", fontWeight: "bold" }} gutterBottom>
									{`Transaction ID:  ${deposit.depositDocumentNumber}`}
								</Typography>
							</Box>
							<Box sx={{ textAlign: "justify", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
								<Grid container>
									<Grid size={6}>
										<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
											{`Crypto Amount`}
										</Typography>
									</Grid>
									<Grid size={6} sx={{ textAlign: "right" }}>
										<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
											{deposit.cryptoAmount > 0
												? `${parseFloat(deposit.cryptoAmount).toFixed(getDecimalsByCrypto(cryptoCurrency))}`
												: ""}
										</Typography>
									</Grid>
								</Grid>
							</Box>
							<Box sx={{ textAlign: "justify", paddingLeft: 3, paddingRight: 3 }}>
								<Grid container>
									<Grid size={6}>
										<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
											{`Exchange`}
										</Typography>
									</Grid>
									<Grid size={6} sx={{ textAlign: "right" }}>
										<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
											{deposit.exchangeRate > 0 ? `${parseFloat(deposit.exchangeRate).toFixed(2)}` : ""}
										</Typography>
									</Grid>
								</Grid>
							</Box>
							<Box sx={{ textAlign: "justify", paddingLeft: 3, paddingRight: 3, paddingBottom: 4 }}>
								<Grid container>
									<Grid size={6}>
										<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
											{`Deposit Total`}
										</Typography>
									</Grid>
									<Grid size={6} sx={{ textAlign: "right" }}>
										<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
											{deposit.currencyAmount > 0 ? `${parseFloat(deposit.currencyAmount).toFixed(2)}` : ""}
										</Typography>
									</Grid>
								</Grid>
							</Box>
						</CardContent>
					</Card>
				</Grid>
			) : (
				<Grid sx={{ width: isMobile ? "100%" : 500 }}>
					<Card>
						<CardContent>
							<Box sx={{ marginTop: 2 }}>
								<Typography sx={{ fontSize: "24px", fontWeight: "bold" }} gutterBottom>
									{title}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<Typography color="#0560FB" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
									{`${cryptoCurrency} ${returnNetwork(network, cryptoCurrency)} Network`}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
									{`Confirmation completed`}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<Typography sx={{ fontSize: "20px", fontWeight: "bold", color: "black" }} gutterBottom>
									{`Updating your account`}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<Typography sx={{ fontSize: "20px", fontWeight: "bold", color: "blackX" }} gutterBottom>
									{`Please wait a moment...`}
								</Typography>
							</Box>
							<Box sx={{ marginTop: 2 }}>
								<CircularProgress color="primary" size={80} thickness={5} />
							</Box>
						</CardContent>
					</Card>
				</Grid>
			)}
		</>
	);
};

export default DepositVerified;
